export const dateTimeConfig = {
  dateFormats: {
    day: "DD",
    shortMonth: "MMM",
    shortWeekday: "ddd",
    shortDateRawOne: "YYYYMMDD",
    shortDateRawFormattedOne: "YYYY-MM-DD",
    shortDateRawTwo: "DDMMYY",
    shortDateRawFormattedTwo: "DD-MM-YY",
    shortDateRawFormattedThree: "DD/MM/YY",
    shortDateRawFormattedFour: "DD/MM/YYYY",
    shortDateRawFormattedFive: "DD-MM-YYYY",
    longDateRawOne: "ddd DD MMM",
    longDateRawTwo: "ddd MMM DD YYYY",
    longDateRawThree: "MMM DD",
    longDateRawFour: "D MMM YYYY",
    longDateRawFive: "ddd MMM DD YYYY",
    longDateFormattedOne: "DD MMM, YYYY",
    longDateFormattedTwo: "ddd, DD MMM YYYY",
    longDateFormattedThree: "ddd, D MMM",
    longDateFormattedFour: "ddd, MMM D",
    longDateFormattedFive: "DD, MMM, YYYY",
    longDateFormattedSix: "ddd, D MMM, YYYY",
  },
  timeFormats: {
    twentyFourHour: "HH",
    twelveHour: "hh",
    minutes: "mm",
    shortTimeRaw: "HHmm",
    shortTimeFormatted: "HH:mm",
    longTimeFormatted: "HH:mm:ss",
  },
  dateTimeFormats: {
    shortDatetimeRawOne: "YYYYMMDDHHmm",
    shortDatetimeRawTwo: "DDMMYYYYHHmm",
    shortDatetimeFormattedOne: "YYYY-MM-DD HH:mm",
    shortDatetimeFormattedTwo: "DD/MM/YYYY HH:mm",
    shortDatetimeFormattedThree: "DD MMM, HH:mm",
    shortDatetimeFormattedFour: "DD-MM-YYYY HH:mm",
    longDatetimeRawOne: "YYYYMMDDHHmmss",
    longDatetimeRawTwo: "ddd MMM DD YYYY HH:mm",
    longDatetimeFormattedOne: "YYYY-MM-DD HH:mm:ss",
    longDatetimeFormattedTwo: "ddd, D MMM, HH:mm",
    longDatetimeFormattedThree: "ddd DD MMM YYYY, HH:mm",
    longDatetimeFormattedFour: "ddd, DD MMM, HH:mm",
    longDatetimeFormattedFive: "ddd DD MMM, HH:mm",
  },
};

export const dateTimeFormats = {
  time: {
    twentyFourHour: "HH",
    twelveHour: "hh",

    twentyFourHourMinute: "HH:mm",
    twelveHourMinute: "hh:mm",

    twentyFourHourMinuteSecond: "HH:mm:ss",
    twelveHourMinuteSecond: "hh:mm:ss",

    minutes: "mm",
    seconds: "ss",
  },
  date: {
    day: "DD",
    shortWeekday: "ddd",

    shortMonth: "MMM",
    longMonth: "MMMM",

    shortYear: "YY",
    longYear: "YYYY",

    shortDate: "DD-MM-YY",
    longDate: "DD-MM-YYYY",

    shortDateMonth: "DD-MM",
    longDateMonth: "DD-MMM",

    shortDateMonthYear: "DD-MM-YY",
    longDateMonthYear: "DD-MMM-YYYY",
  },
  dateTime: {
    shortDateTime: "DD-MM-YY HH:mm",
    longDateTime: "DD-MMM-YYYY HH:mm:ss",

    shortDateTimeMonth: "DD-MMM HH:mm",
    longDateTimeMonth: "DD-MMM HH:mm:ss",

    shortDateTimeYear: "DD-MM-YY HH:mm",
    longDateTimeYear: "DD-MMM-YYYY HH:mm:ss",
  },
};
